// import { history } from "../helpers/history";
import client from './feathers'

export const ServerLogin = (user, url) => () =>
  fetch(`${url}`, {
      method: 'POST',
      body: JSON.stringify(user),
      headers: new Headers({ 'Content-type': 'application/json', Accept: 'application/json'})
  }).then(v => v.json())
  .then(r => {
    // console.log('ServerLogin ',r)
      if (r.message) {
        // console.log('el eror a enviar ', r.message)
        return Promise.reject({error: r.message});
      } else {
        // console.log('lo que tengo ', r)
        localStorage.removeItem('user')
        localStorage.removeItem('feathers-jwt')
        localStorage.setItem("user", JSON.stringify({
          state: true,
          vusk: r.user.vusk,
          data: r.user.id
        }))
        localStorage.setItem("feathers-jwt", r.accessToken)
        return r;
      }

});

export const ServerLoginFeathers = (user) => () => {
  // alert(JSON.stringify(user))
  // const {strategy, email, password} = user
  // console.log(user);
  return client.authenticate(user).then(r => {
    // Logged in
    // console.log('correcto', r)
    // alert(JSON.stringify(r))
    return r
  }).catch(e => {
    // Show login page (potentially with `e.message`)
    // console.log('Authentication error', e);
    ///alert('Authentication error ' + e)
    return [];
  });
}



export const ServerGetData = (url) => () =>{
      let id = JSON.parse(localStorage.user).data
      let token = localStorage["feathers-jwt"]
      // console.log('jaja ',token, id)
      return fetch(`${url}/${id}`, {
        method: 'GET',
        headers: new Headers({ 'Content-type': 'application/json', 'Authorization': token})
      }).then(v => v.json())
      .then(r => {
          // console.log('comprobando ', r)
          if (r.message) {
            //console.log('eliminando local storage...')
            localStorage.removeItem('user')
            localStorage.removeItem('feathers-jwt')
            return Promise.reject(r.data);
          }
          return {
            loggingIn: true,
            user: r,
            token
          };
      });
}

export const ServerGetDataFeathers = () => () =>{
  return client.reAuthenticate().then((r) => {
          // show application page
          //  console.log('reauthenticate ', r)
          return r
        }).catch((error) => {
          //console.log('error de auth ', error)
          return Promise.reject(error);
        });
}

export const CheckSession = (url) => () =>{
  let id = JSON.parse(localStorage.user).data
  let token = localStorage["feathers-jwt"]
  // console.log('jaja ',token, id)
  return fetch(`${url}/${id}`, {
    method: 'GET',
    headers: new Headers({ 'Content-type': 'application/json', 'Authorization': token})
  }).then(v => v.json())
  .then(r => {
      // console.log('comprobando ', r)
      if (r.message) {
        // console.log('eliminando local storage...')
        localStorage.removeItem('user')
        localStorage.removeItem('feathers-jwt')
        return Promise.reject(r.data);
      }
      return {
        loggingIn: true,
        user: {id, vusk: r.vusk},
        token
      };
  });
}


export const serverLogout = () => () => {
  return client.logout().then(r => {/* console.log('cerrando ', r) */})
}

export const serverLoginFailure = () => () => {
  // console.log('failure')
  localStorage.removeItem('user');
  localStorage.removeItem('feathers-jwt');
}

export const serverFind = (id, url, field) => () => {
  // console.log(id, url)
      let token = localStorage["feathers-jwt"]
      return fetch(`${url}/?${field}=${id}`, {
        method: 'GET',
        headers: new Headers({ 'Content-type': 'application/json', 'Authorization': token})
      }).then(v => v.json())
      .then(r => {
          if (r.message) {
            return Promise.reject(r.validation);
          }
          return r.data[0]
      });
}

export const serverFindId = (id, url) => () => {
  // console.log(id, url)
      let token = localStorage["feathers-jwt"]
      return fetch(`${url}/${id}`, {
        method: 'GET',
        headers: new Headers({ 'Content-type': 'application/json', 'Authorization': token})
      }).then(v => v.json())
      .then(r => {
          if (r.error) {
            return Promise.reject(r.validation);
          }
          return r
      });
}

export const feathersFindData2 = (service, field, data) => () => {
  return  client.service(service).find({ query: { [field]: data} }).then(response => {
            //console.log('feathersGetData 5555', response)
              return response
          }).catch( error => {
            //console.log('error feathersGetData 555', error)
              return Promise.reject(error);
          })
}



export const serverFindBalancesId = (id, url) => () => {
  // console.log(id, url)
      let token = localStorage["feathers-jwt"]
      return fetch(`${url}/${id}`, {
        method: 'GET',
        headers: new Headers({ 'Content-type': 'application/json', 'Authorization': token})
      }).then(v => v.json())
      .then(r => {
          // console.log('se obtiene ', r)
          if (r.message) {
            return Promise.reject(r.message);
          }
          return r
      });
}

export const serverFindBalancesCedule = (cedule, url) => () => {
  // console.log(cedule, url)
      let token = localStorage["feathers-jwt"]
      return fetch(`${url}?cedule=${cedule}`, {
        method: 'GET',
        headers: new Headers({ 'Content-type': 'application/json', 'Authorization': token})
      }).then(v => v.json())
      .then(r => {
          // console.log('se obtiene ', r)
          if (r.message) {
            return Promise.reject(r.message);
          }
          return r
      });
}

export const feathersGetData = (service, id) => () => {
  return  client.service(service).get(id).then(response => {
              // console.log('feathersGetData ', response)
              return response
          }).catch( error => {
              return Promise.reject(error);
          })
}

export const feathersFindData = (service, field, data) => () => {
  return  client.service(service).find({ query: { [field]: data} }).then(response => {
              // console.log('feathersGetData ', response.data[0])
              return response.data[0]
          }).catch( error => {
            //console.log('error feathersGetData', error)
              return Promise.reject(error);
          })
}

export const feathersFindDataAll = (service, query) => () => {
  return  client.service(service).find({ query }).then(response => {
               // console.log('feathersGetData ', response)
              return response.data
          }).catch( error => {
            //console.log('error feathersGetDataaLL', error)
              return Promise.reject(error);
          })
}

export const feathersFindGET = (service, query) => () => {
  return  client.service(service).find({ query }).then(response => {
              // console.log('feathersFindGET ', response.data)
              return response.data
          }).catch( error => {
            //console.log('error feathersFindGET', error)
              return Promise.reject(error);
          })
}

export const feathersCreateData = (service, data) => () => {
  return  client.service(service).create(data).then(response => {
               // console.log('feathersCreateData ', response)
              return response
          }).catch( error => {
              //console.log('error feathersCreateData', error)
              return Promise.reject(error);
          })
}

export const feathersDeleteData = (service, data) => () => {
  // console.log('ingresa a crear con ', service, data)
  return  client.service(service).remove(data).then(response => {
              // console.log('feathersDeleteData ', response)
              return response
          }).catch( error => {
              //console.log('error feathersDeleteData', error)
              return Promise.reject(error);
          })
}

export const feathersPatchData = (service, id, data) => () => {
  // console.log('ingresa a crear con ', service, data)
  return  client.service(service).patch(id, data).then(response => {
              // console.log('feathersDeleteData ', response)
              return response
          }).catch( error => {
              //console.log('error feathersDeleteData', error)
              return Promise.reject(error);
          })
}

export const feathersFindDataAllDefault = (service, query) => () => {
  return  client.service(service).find({ query }).then(response => {
               // console.log('feathersGetData ', response)
              return response
          }).catch( error => {
            //console.log('error feathersGetDataaLL', error)
              return Promise.reject(error);
          })
}

